function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useDebounce } from 'react-use';
import { useTranslation } from 'react-i18next';
import { BodyText } from '@keen.io/typography';
import { DropableContainer, Dropdown, DropdownList, DropdownListContainer, MousePositionedTooltip, KEYBOARD_KEYS } from '@keen.io/ui-core';
import { colors } from '@keen.io/colors';
import { useKeypress } from '@keen.io/react-hooks';
import { createFormatterSettings } from '../../../../../utils';
import { serializeFormatterSettings } from '../../../../../serializers';
import { AppContext } from '../../../../../contexts';
import { PrefixAndSuffix } from '../components';
import { InputWrapper, Row, ControlContainer, DropdownWrapper } from './DateTimeFormatter.styles';
import { DATE_FORMATS, TIME_FORMATS } from './constants';
var initialState = {
  prefix: '',
  suffix: '',
  dateFormat: '',
  timeFormat: ''
};

var DateTimeFormatter = function DateTimeFormatter(_ref) {
  var formatValue = _ref.formatValue,
      onUpdateFormatValue = _ref.onUpdateFormatValue;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useContext = useContext(AppContext),
      modalContainer = _useContext.modalContainer;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      dateDropdownOpen = _useState2[0],
      setDateDropdownOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      timeDropdownOpen = _useState4[0],
      setTimeDropdownOpen = _useState4[1];

  var _useState5 = useState(initialState),
      _useState6 = _slicedToArray(_useState5, 2),
      formatterElements = _useState6[0],
      setFormatterElements = _useState6[1];

  var _useState7 = useState(formatValue),
      _useState8 = _slicedToArray(_useState7, 2),
      format = _useState8[0],
      setFormat = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      selectionIndex = _useState10[0],
      setIndex = _useState10[1];

  var TranslatedDateFormats = DATE_FORMATS.map(function (_ref2) {
    var label = _ref2.label,
        value = _ref2.value;
    return {
      label: t(label),
      value: value
    };
  });
  var TranslatedTimeFormats = TIME_FORMATS.map(function (_ref3) {
    var label = _ref3.label,
        value = _ref3.value;
    return {
      label: t(label),
      value: value
    };
  });
  useEffect(function () {
    var settings = createFormatterSettings(formatValue, 'datetime');
    setFormatterElements(function (state) {
      return _objectSpread(_objectSpread({}, state), settings);
    });
  }, [formatValue]);
  useEffect(function () {
    var dateFormat = formatterElements.dateFormat,
        timeFormat = formatterElements.timeFormat;
    var index = 0;

    if (dateDropdownOpen) {
      var precisionIndex = TranslatedDateFormats.findIndex(function (_ref4) {
        var value = _ref4.value;
        return value === dateFormat;
      });
      if (precisionIndex > 0) index = precisionIndex;
    }

    if (timeDropdownOpen) {
      var operationIndex = TranslatedTimeFormats.findIndex(function (_ref5) {
        var value = _ref5.value;
        return value === timeFormat;
      });
      if (operationIndex > 0) index = operationIndex;
    }

    setIndex(index);
    return function () {
      setIndex(null);
    };
  }, [dateDropdownOpen, timeDropdownOpen]);
  useDebounce(function () {
    return onUpdateFormatValue(format);
  }, 300, [format]);
  var selectedDateFormat = TranslatedDateFormats.find(function (format) {
    return format.value === formatterElements.dateFormat;
  }) || TranslatedDateFormats[0];
  var selectedTimeFormat = TranslatedTimeFormats.find(function (format) {
    return format.value === formatterElements.timeFormat;
  }) || null;

  var updateFormat = function updateFormat(values) {
    var newFormatterElements = _objectSpread(_objectSpread({}, formatterElements), values);

    setFormatterElements(newFormatterElements);
    var newFormatValue = serializeFormatterSettings(newFormatterElements);
    setFormat(newFormatValue);
  };

  var onTimeFormatChange = function onTimeFormatChange(format) {
    updateFormat({
      timeFormat: format.value
    });
    setTimeDropdownOpen(!timeDropdownOpen);
  };

  var onDateFormatChange = function onDateFormatChange(format) {
    var enableAdditionalAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var timeFormat = formatterElements.timeFormat;
    setDateDropdownOpen(!dateDropdownOpen);

    if (format.value !== 'original') {
      if (enableAdditionalAction) setTimeDropdownOpen(true);
      timeFormat = timeFormat || TranslatedTimeFormats[0].value;
    } else {
      timeFormat = null;
    }

    updateFormat({
      timeFormat: timeFormat,
      dateFormat: format.value
    });
  };

  var keyboardHandler = useCallback(function (_e, keyCode) {
    switch (keyCode) {
      case KEYBOARD_KEYS.ENTER:
        if (dateDropdownOpen) {
          var _format = TranslatedDateFormats[selectionIndex];
          onDateFormatChange(_format, false);
        }

        if (timeDropdownOpen) {
          var _format2 = TranslatedTimeFormats[selectionIndex];
          onTimeFormatChange(_format2);
        }

        break;

      case KEYBOARD_KEYS.UP:
        if (selectionIndex > 0) {
          setIndex(selectionIndex - 1);
        }

        break;

      case KEYBOARD_KEYS.DOWN:
        if (selectionIndex === null) {
          setIndex(0);
        } else if (dateDropdownOpen && selectionIndex < TranslatedDateFormats.length - 1 || timeDropdownOpen && selectionIndex < TranslatedTimeFormats.length - 1) {
          setIndex(selectionIndex + 1);
        }

        break;

      case KEYBOARD_KEYS.ESCAPE:
        if (dateDropdownOpen) setDateDropdownOpen(false);
        if (timeDropdownOpen) setTimeDropdownOpen(false);
        break;
    }
  }, [selectionIndex, dateDropdownOpen, timeDropdownOpen]);
  useKeypress({
    keyboardAction: keyboardHandler,
    handledKeys: [KEYBOARD_KEYS.ENTER, KEYBOARD_KEYS.ESCAPE, KEYBOARD_KEYS.UP, KEYBOARD_KEYS.DOWN],
    addEventListenerCondition: dateDropdownOpen || timeDropdownOpen,
    eventListenerDependencies: [dateDropdownOpen, timeDropdownOpen, selectionIndex, TranslatedDateFormats, TranslatedTimeFormats]
  });
  return React.createElement("div", null, React.createElement(PrefixAndSuffix, {
    onChange: function onChange(values) {
      return updateFormat(_objectSpread({}, values));
    },
    prefix: formatterElements.prefix,
    suffix: formatterElements.suffix
  }), React.createElement(Row, null, React.createElement(BodyText, {
    variant: "body2",
    fontWeight: "bold"
  }, t('widget_customization_format_value_settings.date_format')), React.createElement(ControlContainer, null, React.createElement(InputWrapper, {
    "data-testid": "date-select"
  }, React.createElement(DropableContainer, {
    variant: "secondary",
    onClick: function onClick() {
      return setDateDropdownOpen(!dateDropdownOpen);
    },
    isActive: dateDropdownOpen,
    value: selectedDateFormat.label,
    dropIndicator: true,
    onDefocus: function onDefocus() {
      return setDateDropdownOpen(false);
    }
  }, selectedDateFormat.label), React.createElement(Dropdown, {
    isOpen: dateDropdownOpen
  }, React.createElement(DropdownListContainer, {
    scrollToActive: true,
    maxHeight: 150
  }, function (activeItemRef) {
    return React.createElement(DropdownList, {
      ref: activeItemRef,
      items: TranslatedDateFormats,
      setActiveItem: function setActiveItem(_ref6) {
        var value = _ref6.value;
        return TranslatedDateFormats[selectionIndex] && TranslatedDateFormats[selectionIndex].value === value;
      },
      onClick: function onClick(e, format) {
        return onDateFormatChange(format);
      }
    });
  }))), React.createElement(InputWrapper, {
    "data-testid": "time-select"
  }, React.createElement(MousePositionedTooltip, {
    isActive: selectedDateFormat.value === 'original',
    tooltipPortal: modalContainer,
    tooltipTheme: "dark",
    renderContent: function renderContent() {
      return React.createElement(BodyText, {
        variant: "body2",
        color: colors.white[500]
      }, t('widget_customization_format_value_settings.select_the_date_format_first'));
    }
  }, React.createElement(DropdownWrapper, {
    isDisabled: selectedDateFormat.value === 'original'
  }, React.createElement(DropableContainer, {
    variant: "secondary",
    onClick: function onClick() {
      return setTimeDropdownOpen(!timeDropdownOpen);
    },
    isActive: timeDropdownOpen,
    value: selectedTimeFormat ? selectedTimeFormat.label : t('widget_customization_format_value_settings.time_format'),
    dropIndicator: true,
    onDefocus: function onDefocus() {
      return setTimeDropdownOpen(false);
    }
  }, selectedTimeFormat ? selectedTimeFormat.label : t('widget_customization_format_value_settings.time_format')), React.createElement(Dropdown, {
    isOpen: timeDropdownOpen
  }, React.createElement(DropdownListContainer, {
    scrollToActive: true,
    maxHeight: 150
  }, function (activeItemRef) {
    return React.createElement(DropdownList, {
      ref: activeItemRef,
      items: TranslatedTimeFormats,
      setActiveItem: function setActiveItem(_ref7) {
        var value = _ref7.value;
        return TranslatedTimeFormats[selectionIndex] && TranslatedTimeFormats[selectionIndex].value === value;
      },
      onClick: function onClick(e, format) {
        return onTimeFormatChange(format);
      }
    });
  }))))))));
};

export default DateTimeFormatter;